export const SPENDING_LIMIT_PERIOD = {
  MONTH: 'month',
  WEEK: 'week',
}
